import { appliedReportActionCreators } from './applied';
import { currentReportActionCreators } from './current';

export default {
    ...appliedReportActionCreators,
    ...currentReportActionCreators,
};
